import axios from 'axios';
import Swal from 'sweetalert2';
const defaults = {
    title: "Confirmar",
    text: "",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ed5565",
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
};
export default{
    methods:{
        isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        },
        isNumber(e) {
            let key = e.keyCode || e.which;
            let keyString = String.fromCharCode(key).toLowerCase();
            let letters = "0123456789";
            let specials = [8, 9, 37, 39, 46, 44];
            let keySpecial = false;
            for (let i in specials) {
                if (key == specials[i]) {
                    keySpecial = true;
                    break;
                }
            }
            if (letters.indexOf(keyString) == -1 && !keySpecial) {
                e.preventDefault();
                return false;
            }
        },
        isLetter(e) {
            let key = e.keyCode || e.which;
            let keyString = String.fromCharCode(key).toLowerCase();
            let letters = "ABCDEFGHIJKLMÑNOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyz";
            let specials = [32];
            let keySpecial = false;
            for (let i in specials) {
                if (key == specials[i]) {
                    keySpecial = true;
                    break;
                }
            }
            if (letters.indexOf(keyString) == -1 && !keySpecial) {
                e.preventDefault();
                return false;
            }
        },
        isMail(e) {
            let key = e.keyCode || e.which;
            let keyString = String.fromCharCode(key).toLowerCase();
            let letters = "ABCDEFGHIJKLMÑNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz.@_0123456789";
            let specials = [];
            let keySpecial = false;
            for (let i in specials) {
                if (key == specials[i]) {
                    keySpecial = true;
                    break;
                }
            }
            if (letters.indexOf(keyString) == -1 && !keySpecial) {
                e.preventDefault();
                return false;
            }
        },
        validEmail (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        alert(options, callback){
            if(typeof options.icon == "undefined")
                options.icon = "info";
            options.showCancelButton=false;   
            options.confirmButtonText='Aceptar';
            options.confirmButtonColor='#3085d6';
            const settings = $.extend({}, defaults, options);
            if(this.isFunction(callback)){
                Swal.fire(settings).then((result) => {
                    callback(true);
                })
                return;
            }
            Swal.fire(settings);
        },
        alertSuccess(message,callback){
            this.alert({icon:'success',title:'Mensaje',text:message},callback);
        },
        alertWarning(message,callback){
            this.alert({icon:'warning',title:'Advertencia',text:message},callback);
        },
        alertError(message,callback){
            this.alert({icon:'error',title:'Error',text:message},callback);
        },
        alertInfo(message,callback){
            this.alert({icon:'info',title:'Info',text:message},callback);
        },
		downloadItem(file, label){
            axios({
                url: file,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                console.log(url);
                const link = document.createElement('a');
                console.log(link);
                link.href = url;
                link.setAttribute('download', label);
                document.body.appendChild(link);
                link.click();
            });
        },
	}
}